import { Component, OnInit } from '@angular/core'
import 'rxjs/add/operator/toPromise'
import { Router } from '@angular/router'
import { AuthService } from '../services/auth.services'
import { RestServices } from '../services/rest.services'
import { Login } from '../../models/login'
import { CookieService } from 'ngx-cookie-service'

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['../app_manager/top/top.component.css', './login.component.css'],
})
export class LoginComponent implements OnInit {
    en = {}
    showEN = true
    isIEOrEdge = false
    isIEOrEdgeNotice = false
    organizationId: ''
    userId: ''
    password: ''
    token: ''
    errorMessage: any
    hiddenModal = 'hidden'
    showOption: any
    filterLang: string
    // check language default show modal
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    optionArr = [
        { id: 1, name: 'English', lang: 'true' },
        { id: 2, name: '日本語', lang: 'false' },
    ]
    optionArrCopy = this.optionArr.slice() // copy of optionArr
    styleVisibility: any
    isSafari

    constructor(public router: Router, private authData: AuthService, private checkLogin: RestServices, private cookieService: CookieService) {
    }

    ngOnInit() {
        if(localStorage.getItem('classThemeBody')) {
            jQuery('body').attr('class', localStorage.getItem('classThemeBody'))
        } else {
            jQuery('body').attr('class', 'blue')
        }
        let newVariable: any
        newVariable = window.navigator
        if (('standalone' in newVariable) && !newVariable.standalone) {
            // .... code here ....
            this.isSafari = /iPad|iPhone|iPod/.test(navigator.userAgent)
            // if (!this.isSafari) {
            //     this.check_Login();
            // }
        } else {
            this.check_Login()
        }
        if (this.langDefault) {
            this.styleVisibility = { visibility: 'visible' }
        }
        this.isIEOrEdge = /msie\s|trident\//i.test(window.navigator.userAgent)
    }

    alertSecurity() {
        this.isIEOrEdge = false
        this.isIEOrEdgeNotice = true
    }

    loadPageLogin() {
        return window.location.reload()
    }

    check_Login() {
        if (this.authData.getItem('user')) {
            const user = JSON.parse(this.authData.getItem('user'));
            const expires = parseInt((user.expiresInSeconds)) * 1000;
            const timeOut = parseInt(this.authData.getItem('timeout')) + expires;
            const timeNow = Date.now();
            if(timeOut > timeNow){
                this.router.navigateByUrl('/app/top')
            }
        }
    }

    login() {
        const loginUrl = 'account/login'
        const topUrl = 'account/renew'
        if (this.token) {
            localStorage.setItem('token', this.token)
            this.checkLogin.http_post(topUrl, null, JSON.stringify(localStorage.getItem('token')))
            .subscribe(
                success => {
                    this.authData.setItem('user', success)
                    this.authData.setItem('token', success['token'])
                    this.authData.setItem('timeout', Date.now())
                    this.router.navigateByUrl('/app/top')
                    this.cookieService.set('token', success['token'], 1)
                },
                err => {
                    if (localStorage.getItem('lang') === 'false') {
                        this.errorMessage = '不確かなトークン'
                    } else {
                        this.errorMessage = 'Incorrect token'
                    }
                })
        } else {
            const newData: Login = new Login()
            newData.organizationId = this.organizationId
            newData.userId = this.userId
            newData.password = this.password
            this.checkLogin.http_post(loginUrl, newData)
            .subscribe(success => {
                    this.authData.setItem('user', success)
                    this.authData.setItem('token', success['token'])
                    this.authData.setItem('timeout', Date.now())
                    if (success['lang'] && !localStorage.getItem('lang')) {
                        localStorage.setItem('lang', (success['lang'] == 'en') + '')
                    }
                    this.router.navigateByUrl('/app/top')
                    this.cookieService.set('token', success['token'], 1)
                },
                err => {
                    console.error(err)
                    if (localStorage.getItem('lang') === 'false') {
                        if (err.error.isLocked) {
                            this.errorMessage = 'Your account has been locked. Please make payment for continue using Orthocomm.'
                        } else if (err.error.accessCounter > 5) {
                            this.errorMessage = 'ログインミスが一定回数を超えたのでロックがかかりました。以下のリンクからパスワード再設定を行ってください。'
                        } else {
                            this.errorMessage = 'IDまたはパスワードが間違っています'
                        }
                    } else {
                        if (err.error.isLocked) {
                            this.errorMessage = 'Your account has been locked. Please make payment for continue using Orthocomm.'
                        } else if (err.error.accessCounter > 5) {
                            this.errorMessage = 'It was locked because you made a certain number of login mistakes. Please reset your password from the link below.'
                        } else {
                            this.errorMessage = 'Incorrect user id or password'
                        }
                    }
                })
        }
    }

    // show modal language
    selectLanguage() {
        this.hiddenModal = 'active'
    }

    // hiden modal
    hidenModal() {
        this.hiddenModal = 'hidden'
    }

    selectOption(id, lang) {
        this.showOption = 'showOption_' + id
        if (this.showOption || this.langDefault === lang) {
            this.styleVisibility = { visibility: 'visible' }
            localStorage.setItem('lang', lang)
            this.langDefault = lang
            this.hidenModal()
        }
    }

    // search language
    search(): void {
        const term = this.filterLang
        this.optionArr = this.optionArrCopy.filter(function(tag) {
            return tag.name.indexOf(term) >= 0
        })
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts